
export default [
    {
      path: '/resultPage',
      name: 'resultPage',
      component: () => import('../../views/resultPage/index.vue'),
      meta: {
        title: '',
        // pageKey: 'Task_Paradise_home'
      }
    }
  ]